module.exports = __webpack_public_path__ + "static/img/Wechat.e52c4ea.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent/Wechat.jpeg
// module id = ZoDh
// module chunks = 74